import React, { useState } from "react";
import { Form, Input, Button, Layout, Typography, Row } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory, Link } from "react-router-dom";

import { passwordValidation } from "../../../utils/Validations";

import "../../../styles/PageStyles/Login.less";

const { Content } = Layout;
const { Title } = Typography;

const ResetPassword = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
      console.log(values)
  };

  return (
    <Layout className="login-layout">
      <Content>
        <Form form={form} name="normal_login" className="login-form" onFinish={onFinish} layout="vertical">
          <Row justify="center">
            <Title level={2} className="fg-primary">
              Input New Password
            </Title>
          </Row>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: "This field is required"}, {pattern: passwordValidation, message: "Must have number, special character, uppercase. Minimum 8 length" }]}>
          
            <Input.Password size="large" />
          </Form.Item>
          <Form.Item
              name="confirmPassword"
              label="Confirm Password"
              dependencies={["password"]}
              rules={[
                { required: true, message: "This field is required" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("The two passwords that you entered do not match!"));
                  },
                }),
              ]}>
              <Input.Password size="large" />
            </Form.Item>
          <Form.Item>
            <Button block size="large" type="primary" disabled={loading} htmlType="submit">
              {loading && <LoadingOutlined />} Reset Password
            </Button>
          </Form.Item>
          <Form.Item>
              <Link to="/login">
                <Button type="text">Go Home</Button>
              </Link>
          </Form.Item>
        </Form>
      </Content>
    </Layout>
  );
};

export default ResetPassword;
